<main @fade>
  <nb-card>
    <nb-card-header>
      <app-list-actions [list]="this"/>
    </nb-card-header>

    <nb-card-body>
      <ngx-table [nbSpinner]="loading"
                 #table
                 [configuration]="configuration"
                 [data]="data | async"
                 [columns]="columns"
                 [pagination]="pagination"
                 (event)="eventEmitted($event)"
      >
        <ng-template #colTemplate let-row let-colIndex="colIndex" let-rowIndex="rowIndex" let-column="column">
          <app-list-columns [list]="this" [row]="row" [colIndex]="colIndex" [rowIndex]="rowIndex" [column]="column"/>
        </ng-template>
      </ngx-table>
    </nb-card-body>
  </nb-card>
</main>
